

import * as types from '../constants/actionConstants';
import { createSingleAction } from '../../utils/reduxActions'

export const getAllMenuAct = createSingleAction(types.catMenuConst.GET_MENU_LIST);
export const getAllMenuActSuccess = createSingleAction(types.catMenuConst.GET_MENU_LIST_SUCCESS);

export const addEposMenuAct = createSingleAction(types.catMenuConst.ADD_EPOS_MENU);

export const updateEposMenuAct = createSingleAction(types.catMenuConst.UPDATE_EPOS_MENU);
export const deleteEposMenuAct = createSingleAction(types.catMenuConst.DELETE_EPOS_MENU);

export const getAllMenuByRoleAct = createSingleAction(types.catMenuConst.GET_ALL_MENU_BY_ROLE);

export const getEposMenuFindChildAct = createSingleAction(types.catMenuConst.GET_MENU_CHILDS);
export const getEposMenuFindChildActSuccess = createSingleAction(types.catMenuConst.GET_MENU_CHILDS_SUCCESS);

export const getTreeMenuPublicAct = createSingleAction(types.catMenuConst.GET_MENU_TREE_PUBLIC);
export const getTreeMenuPublicActSuccess = createSingleAction(types.catMenuConst.GET_MENU_TREE_PUBLIC_SUCCESS);

export const resetStateAct = createSingleAction(types.catMenuConst.MENU_RESET_STATE);



